import React from 'react'
import { Cart3Broken } from 'solar-icons'

import { Hint } from '@/components/ui'

export const KotPlaceholder = () => {
  return (
    <div className="flex h-full min-h-[50svh] w-full flex-col items-center justify-center gap-4 rounded-lg px-20">
      <Cart3Broken className="size-20 text-gray-200" strokeWidth={0.6} />
      <div className="flex flex-col items-center gap-2 text-center">
        <span className="text-base font-medium">Kitchen's all clear!</span>
        <Hint>Time for a well-deserved breather. You've earned it!</Hint>
      </div>
    </div>
  )
}
